import { empty } from 'fp-ts/lib/Array';
export var NON_FIELD_ERRORS = 'non_field_errors';
export function getErrors(error, field) {
    if (typeof error.data !== 'undefined' && error.data.errors && Array.isArray(error.data.errors)) {
        return error.data.errors.filter(function (e) { return e.field === field; }).map(function (e) { return e.message; });
    }
    return empty;
}
export function getNonFieldErrors(error) {
    if (typeof error.data !== 'undefined' && error.data.errors && Array.isArray(error.data.errors)) {
        return error.data.errors.filter(function (e) { return !e.field; }).map(function (e) { return e.message; });
    }
    return ['Failed to process the request.'];
}
export function hasErrors(error, field) {
    return (typeof error.data !== 'undefined' &&
        error.data.errors &&
        Array.isArray(error.data.errors) &&
        error.data.errors.some(function (e) { return e.field === field; }));
}
export function hasNonFieldErrors(error) {
    return (typeof error.data === 'undefined' ||
        (error.data.errors && Array.isArray(error.data.errors) && error.data.errors.some(function (e) { return !e.field; })));
}
export function hasFieldOrGlobalErrors(error, field) {
    return hasErrors(error, field) || hasNonFieldErrors(error);
}
export function fixNonFieldErrors(error) {
    if (Array.isArray(error.data)) {
        error.data = { errors: error.data.map(function (message) { return ({ message: message, code: '' }); }) };
    }
    return error;
}
//# sourceMappingURL=api.model.js.map